import { Router } from 'express';
import { db } from '../storage';
import { AttendanceRecord } from '../../src/types';

export const attendanceRouter = Router();

// Get attendance for a session
attendanceRouter.get('/:sessionId', (req, res) => {
  const { sessionId } = req.params;
  const teacherId = req.query.teacherId as string;
  if (!teacherId) return res.status(400).json({ error: 'Missing teacherId' });

  const records = db.getAttendance(teacherId, sessionId);
  res.json(records);
});

// Save attendance records batch
attendanceRouter.post('/:sessionId', (req, res) => {
  const { sessionId } = req.params;
  const { teacherId, classId, records } = req.body;
  if (!teacherId || !sessionId || !Array.isArray(records)) {
    return res.status(400).json({ error: 'Dữ liệu điểm danh không hợp lệ' });
  }

  const saved = db.saveAttendanceBatch(teacherId, sessionId, records);
  res.json({ success: true, saved });
});
